import {Injectable} from '@angular/core';
import {HttpService} from '@app/core/services/http.service';
import {AuthService} from '@app/core/services/auth.service';
import {BaseService} from '@app/core/services/base.service';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {map} from 'rxjs/operators';
import {Activity, ActivitySubjectTypes} from '@app/core/models/activity.model';
import {PaginationHolder} from '@app/core/models/pagination.model';

@Injectable()
export class ActivityService extends BaseService {
	constructor(
		public authService: AuthService,
		public interService: InternationalizationService,
		public httpService: HttpService,
		public store: Store<IAppState>,
	) {
		super(authService, interService, httpService, store);
	}

	public fresh(params?): Activity {
		if (!params) {
			return new Activity(this.tenantTZ, this.interService, this.store);
		}

		return new Activity(this.tenantTZ, this.interService, this.store).deserialize(params);
	}

	public getActivities(departmentId: number, subjectType?: ActivitySubjectTypes, subjectId?: number): Observable<PaginationHolder<Activity>> {
		return this.httpService.getJson<PaginationHolder<Activity>>('departments/' + departmentId + '/activities', {
			'filter[subject_type]': subjectType,
			'filter[subject_id]': subjectId,
		}).pipe(map(res => {
			res.data = res.data.map(d => this.fresh(d));

			return res;
		}));
	}

	public getActivity(departmentId: number, activityId: number): Observable<Activity> {
		return this.httpService.getJson<Activity>('departments/' + departmentId + '/activities' + activityId);
	}

	public getRelationActivity(departmentId: number, model: ActivitySubjectTypes, modelId: number, relation: 'shiftStock' | 'shiftStockBids'): Observable<PaginationHolder<Activity>> {
		return this.httpService.getJson<PaginationHolder<Activity>>('departments/' + departmentId + '/activities/relation', {
			model,
			model_id: modelId,
			relation,
		}).pipe(map(res => {
			res.data = res.data.map(d => this.fresh(d));
			
			return res;
		}));
	}
}
